import { Controller } from '@hotwired/stimulus';

export default class TurboFrameScrollStealController extends Controller {
  connect() {
    this.element.addEventListener('turbo:frame-render', () => {
      this.element.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'start' });
    });
  }
}
